import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'app.signup.createAccountForm.title',
        defaultMessage: 'Create your account'
    },
    email: {
        id: 'app.signup.createAccountForm.email',
        defaultMessage: 'Email'
    },
    firstName: {
        id: 'app.signup.createAccountForm.firstName',
        defaultMessage: 'First name'
    },
    lastName: {
        id: 'app.signup.createAccountForm.lastName',
        defaultMessage: 'Last name'
    },
    enterMandatory: {
        id: 'app.signup.createAccountForm.enterMandatory',
        defaultMessage: 'Enter (Mandatory)'
    },
    password: {
        id: 'app.signup.createAccountForm.password',
        defaultMessage: 'Password'
    },
    selectPassword: {
        id: 'app.signup.createAccountForm.selectPassword',
        defaultMessage: 'Select a password...'
    },
    termsNotAccepted: {
        id: 'app.signup.createAccountForm.termsNotAccepted',
        defaultMessage: 'You must accept the terms and conditions in order to create your account.'
    },
    createAccount: {
        id: 'app.signup.createAccountForm.createAccount',
        defaultMessage: 'Create account'
    },
    lastNameError: {
        id: 'app.signup.createAccountForm.lastNameError',
        defaultMessage: 'Please enter a last name'
    },
    firstNameError: {
        id: 'app.signup.createAccountForm.firstNameError',
        defaultMessage: 'Please enter a first name'
    },
    warning: {
        id: 'app.signup.createAccountForm.warning',
        defaultMessage: 'Fill out the required fields to continue'
    }
});
